export default {"src":"/_next/static/media/ic-back-arrow.afb531f2.svg","height":24,"width":24};